var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerifiedPurchase = function SvgVerifiedPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M10.836 4.045C8.629 3.484 7.691 2.3 7.691 2.3h-.09s-1.397 1.77-4.8 2.002v5.781s-.094 2.564 4.8 4.105h.09c4.895-1.537 4.802-4.105 4.802-4.105v-2.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "m13.188 4.07-6.06 5.8-2.034-2.031"
  })));
};
export default SvgVerifiedPurchase;